import React, { Fragment, Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    TextField,
    Button,
    FormHelperText,
    Checkbox,
    FormControlLabel
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';


import { Translate } from '../../Localization/Translate';
import Api from '../../../nibeApi';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentLoaded: false,

            // Check
            emailCheckValue: '',

            // Activation
            activationDataIsValid: false,
            activationEmailValue: null,
            activationProjectNameValue: null,
            activationFailed: false,

            // New customer data
            emailNewValue: null,
            firstNameNewValue: null,
            lastNameNewValue: null,
            phoneNewValue: null,
            companyNameNewValue: null,
            companyRegNoNewValue: null,
            newCustomerValidated: false,
            newCustomerDataSentOk: false,

            agreementIsApproved: false,

            classes: '',

            showCheckEmailLoader: false,
        };
    }

    componentDidMount() {
        this.setState({
            componentLoaded: true,
            activationProjectNameValue: this.props.activationProjectNameValue
        });
    }

    updateInputData(elementName, value) {
        const scope = this;
        this.setState({
            [elementName]: value,
        });

        setTimeout(function () {
            const {
                emailNewValue,
                firstNameNewValue,
                lastNameNewValue,
                phoneNewValue,
                companyNameNewValue,
                companyRegNoNewValue,
                activationEmailValue,
                activationProjectNameValue,
                agreementIsApproved
            } = scope.state;

            const isValid = agreementIsApproved && emailNewValue && firstNameNewValue && lastNameNewValue && phoneNewValue && companyNameNewValue && companyRegNoNewValue && emailNewValue.indexOf("@") !== -1;
            const activationDataIsValid = activationEmailValue && activationProjectNameValue && activationEmailValue.indexOf("@") !== -1;

            scope.setState({
                newCustomerValidated: isValid,
                activationDataIsValid
            });
        }, 200);
    }

    sendNibeForm = (formName) => {
        const scope = this;
        const { emailCheckValue, emailNewValue, firstNameNewValue, lastNameNewValue, phoneNewValue, companyNameNewValue, companyRegNoNewValue } = this.state;

        switch (formName) {
            case 'emailCheck':
                // j.raatjes@breman.nl
                this.setState({ showCheckEmailLoader: true }, function() {
                    Api.makeCall("get", `Contacts/getcontact?emailAddress=${encodeURI(emailCheckValue.trim())}&market=${this.props.config}` , {}, false, function (response) {
                        scope.props.updateState('activationEmailValue', emailCheckValue);
                        if (response && response.data.contactid) {
                            scope.props.updateState("userExists", true);
                            if (response.data.statuscode !== 1) {
                                scope.props.updateState("userNotActive", true);
                            } else {
                                scope.props.updateState("customerDataObject", response.data);
                            }
                        }
                    }, function () {
                        scope.setState({ emailNewValue: emailCheckValue, showCheckEmailLoader: false });
                        scope.props.updateState("addNewUser", true);
                    });
                });

                break;
            case 'sendCustomerRequestData':
                // j.raatjes@breman.nl

                const data = {
                    "emailAddress": emailNewValue,
                    "firstName": firstNameNewValue,
                    "lastName": lastNameNewValue,
                    "phoneNumber": phoneNewValue,
                    "companyName": companyNameNewValue,
                    "companyRegNumber": companyRegNoNewValue,
                    "market": this.props.config,
                };

                Api.makeCall("post", 'Contacts/newcontact', data, false, function (response) {
                    scope.setState({
                        newCustomerDataSentOk: true,
                    });
                }, function () {
                    scope.props.updateState('activationEmailValue', emailNewValue);
                });
                break;
            case 'sentActivationDetails':
                // j.raatjes@breman.nl
                Api.makeCall("post", 'Contacts/newcontact', {}, false, function (response) {
                    
                }, function () {
                    scope.setState({
                        activationFailed: true,
                    });
                });
                break;
            default:
                break;
        }
    };

    render() {
        const classes = makeStyles(() => ({
            root: {
                width: '100%',
            },
        }));

        const { addNewUser, userExists, updateState, customerDataObject, userNotActive } = this.props;
        const { componentLoaded, emailCheckValue, newCustomerValidated, activationDataIsValid, activationFailed, agreementIsApproved, newCustomerDataSentOk } = this.state;

        return (
            <Fragment>
                {componentLoaded &&
                    <Fragment>
                        {!userExists ? (
                            <Fragment>
                                {!addNewUser ? (
                                    <form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                                        <Grid container alignItems="flex-start" spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" variant="outlined" label={Translate("QuoteTool/step1/emailinputlabel")} onChange={(event) => { this.updateInputData('emailCheckValue', event.target.value) }} />
                                            </Grid>
                                        </Grid>
                                        <Grid container alignItems="flex-start" spacing={2}>
                                            <Grid item xs={12}>
                                                <Button
                                                    type='submit'
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => this.sendNibeForm('emailCheck')}
                                                    className={classes.button}
                                                    disabled={!emailCheckValue || emailCheckValue.indexOf('@') === -1 || this.state.showCheckEmailLoader}
                                                >
                                                    {Translate("QuoteTool/step1/checkemailbutton")}
                                                    {this.state.showCheckEmailLoader ? (
                                                        <CircularProgress className='button__loader' color='secondary' size={20} />
                                                    ) : null}
                                                </Button>

                                            </Grid>
                                        </Grid>
                                    </form>
                                    ) : (
                                    <Fragment>
                                        {newCustomerDataSentOk ? (
                                            <p>
                                                {Translate('QuoteTool/step1/newcustomersent')}
                                            </p>
                                            ) : (
                                                <form className = {classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                                                    <Grid container alignItems="flex-start" spacing={2}>
                                                        <Grid item xs={12} sm={12}>
                                                            <p>
                                                                {Translate('QuoteTool/step1/emaildoesntexist')}
                                                            </p>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container alignItems="flex-start" spacing={2}>
                                                        <Grid item xs={12} sm={12}>
                                                            <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" variant="outlined" defaultValue={this.state.emailNewValue} label={Translate("QuoteTool/step1/emailinputlabel")} onChange={(event) => this.updateInputData('emailNewValue', event.target.value)} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container alignItems="flex-start" spacing={2}>
                                                        <Grid item xs={12} sm={12} md={6}>
                                                            <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" variant="outlined" label={Translate("QuoteTool/step1/firstnameinputlabel")} onChange={(event) => this.updateInputData('firstNameNewValue', event.target.value)} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={6}>
                                                            <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" variant="outlined" label={Translate("QuoteTool/step1/lastnameinputlabel")} onChange={(event) => this.updateInputData('lastNameNewValue', event.target.value)} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container alignItems="flex-start" spacing={2}>
                                                        <Grid item xs={12} sm={12} md={6}>
                                                            <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" variant="outlined" label={Translate("QuoteTool/step1/phoneinputlabel")} onChange={(event) => this.updateInputData('phoneNewValue', event.target.value)} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={6}>
                                                            <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" variant="outlined" label={Translate("QuoteTool/step1/companynameinputlabel")} onChange={(event) => this.updateInputData('companyNameNewValue', event.target.value)} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container alignItems="flex-start" spacing={2}>
                                                        <Grid item xs={12}>
                                                            <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" variant="outlined" label={Translate("QuoteTool/step1/companynumberinputlabel")} onChange={(event) => this.updateInputData('companyRegNoNewValue', event.target.value)} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container alignItems="flex-start" spacing={2}>
                                                        <Grid item xs={12}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        onChange={(e) => this.updateInputData('agreementIsApproved', e.target.checked)}
                                                                        name="agreementIsApproved"
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={<span>{Translate("QuoteTool/step1/newcustomerterms")}&nbsp;<a href={Translate('QuoteTool/step1/newcustomertermslink')} target="_blank">{Translate('QuoteTool/step1/newcustomertermstext')}</a></span>}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container alignItems="flex-start" spacing={2}>
                                                        <Grid item xs={12} sm={12} md={6}>
                                                            <Button
                                                                type="submit"
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => this.sendNibeForm('sendCustomerRequestData')}
                                                                className={classes.button}
                                                                disabled={!newCustomerValidated || !agreementIsApproved}
                                                            >
                                                                {Translate("QuoteTool/step1/sendrequest")}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </form>
                                            )}
                                    </Fragment>
                                )}
                            </Fragment>
                        ) : (
                            <div>
                                {userNotActive ? (
                                    <div>
                                        <Grid container alignItems="flex-start" spacing={2}>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <p>
                                                    {Translate('QuoteTool/step1/blockedemail')}
                                                </p>
                                            </Grid>
                                        </Grid>
                                    </div>
                                ) : (
                                    <form className = {classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                                        <Grid container alignItems="flex-start" spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField fullWidth ref={this.checkEmailFieldRef} id="standard-basic" defaultValue={this.state.activationProjectNameValue} variant="outlined" label={Translate("QuoteTool/step1/projectname")} onChange={(event) => { this.updateInputData('activationProjectNameValue', event.target.value); updateState('activationProjectNameValue', event.target.value);}} />
                                            </Grid>
                                        </Grid>

                                        <Grid container alignItems="flex-start" spacing={2}>
                                            <Grid item xs={12} sm={8} md={6}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => this.props.updateSteps(1, 1)}
                                                    className={classes.button}
                                                    disabled={this.state.activationProjectNameValue === null}
                                                >
                                                    {Translate('QuoteTool/general/buttonnext')}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </div>
                        )}
                        {false &&
                            <FormHelperText>labelPlacement start</FormHelperText>
                        }
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default Contact;